import $ from "jquery";
import "jquery-ui";
import ko from "knockout";
import workspace from "flow/viewModels/workspace";
import config from "flow/config";
import moduleLoader from "flow/wrappers/moduleLoader";
import commandRepository from "flow/cli/commandRepository";
import Component from "flow/Component";
import ToolbarItemManifestEx from "flow/manifests/ToolbarItemManifestEx";

const dash = document.getElementById(config.elementIdsWithoutHash.dash);
const $dash = $(dash);
const dashFilter = document.getElementById(config.elementIdsWithoutHash.dashFilter);
const $dashFilter = $(dashFilter);

const isVisible = ko.observable<boolean>(false);

const componentList = ko.observableArray<Component>();

const inNormalMode = ko.observable<boolean>(true);
const terminalHandle = ko.observable<HTMLElement>();

function show() {
    filter("");
    updateComponentList();
    $dash.fadeIn(300, function () {
        if (inNormalMode()) {
            $dashFilter.focus();
        } else {
            terminalHandle().focus();
        }
    });
}

function hide() {
    $dash.fadeOut(300, function () {
        if (inNormalMode()) {
            $dashFilter.blur();
        } else {
            terminalHandle().blur();
        }
    });
}

const filter = ko.observable();

const items = ko.pureComputed<ToolbarItemManifestEx[]>(() => {
    const myFilter = filter();
    if (!myFilter) {
        return workspace.navigationPanelItems();
    } else {
        return workspace
            .navigationPanelItems()
            .filter(item => item.tooltip.toLowerCase().indexOf(myFilter.toLowerCase()) >= 0);
    }
});

function onItem(item: ToolbarItemManifestEx) {
    workspace.getMyFlow().activateById(item.id);
    hide();
}

const components = ko.pureComputed<Component[]>(function () {
    const myFilter = filter();

    if (!myFilter) {
        return componentList();
    } else {
        return componentList().filter(item => item.title().toLowerCase().indexOf(myFilter.toLowerCase()) >= 0);
    }
});

function updateComponentList() {
    let visibleComponents = workspace.viewport().visibleComponents();
    // Remove shadow container (the one missing title)
    visibleComponents = visibleComponents.filter(item => item.title() !== undefined);
    componentList(visibleComponents);
}

function onComponent(component: Component) {
    workspace.viewport().selectByInstance(component);
    hide();
}

function onKeyDown(event: KeyboardEvent) {
    if (!event.defaultPrevented && event.keyCode) {
        switch (event.keyCode) {
            case $.ui.keyCode.ESCAPE:
                return onHide(event);
            case $.ui.keyCode.ENTER:
                return onActivate(event);
        }
    }
    return undefined;
}

function onHide(event: Event) {
    event.preventDefault();
    hide();
    return false;
}

function onActivate(event: Event) {
    event.preventDefault();
    if (items().length > 0) {
        onItem(items()[0]);
        hide();
    } else if (components().length > 0) {
        onComponent(components()[0]);
        hide();
    } else if (filter() === "console") {
        moduleLoader.requireSingleAsync("flow/bindings/commanderBinding").then(() => {
            commandRepository.init();
            inNormalMode(false);
        });
    } else {
        hide();
    }
    return false;
}

function init() {
    dash.addEventListener("keydown", onKeyDown);
    dashFilter.addEventListener("keydown", onKeyDown);
}

function leaveTerminal() {
    inNormalMode(true);
    filter("");
    $dashFilter.focus();
}

export default {
    init: init,
    root: $dash[0],
    filter: filter,
    items: items,
    onItem: onItem,
    components: components,
    onComponent: onComponent,
    show: show,
    hide: hide,
    isVisible: isVisible,
    inNormalMode: inNormalMode,
    terminalHandle: terminalHandle,
    leaveTerminal: leaveTerminal
};
